import styled from "styled-components/macro";
import { NavigationControl } from "react-map-gl";

import { boxShadow, space } from "shared/styles/constants";

export interface MapContainerProps {
  borderRadius?: string;
}

export const MapContainer = styled.div<MapContainerProps>`
  height: 100%;
  width: 100%;

  position: relative;

  .mapboxgl-canvas {
    border-radius: ${({ borderRadius }) => borderRadius};
  }

  .mapboxgl-ctrl-logo {
    display: none !important;
  }
`;

export interface StyledNavigationProps {
  navigationPosition?: "top-right" | "bottom-right";
}

export const StyledNavigationControl = styled(
  NavigationControl
)<StyledNavigationProps>`
  position: absolute;

  margin: ${space.s};

  ${({ navigationPosition }) =>
    navigationPosition === "bottom-right" ? `bottom: 0px` : `top: 0`};

  right: 0;

  border-radius: 0 !important;
  box-shadow: ${boxShadow.m} !important;
`;
